
import { defineComponent } from "vue";
import Three_js from "./components/Three_js.vue";

export default defineComponent({
  name: "App",
  components: {
    Three_js,
  },
});
